/**
 * Envoi d'un formulaire vers Systeme.io sans quitter la boutique.
 *
 * A utiliser dans n'importe quelle section : ecrivez votre propre HTML, posez
 * data-sio-form sur le <form> et son action sur l'URL d'abonnement Systeme.io.
 *
 *   <form data-sio-form method="post" action="https://systeme.io/embedded/XXX/subscription">
 *     <input type="email" name="email" required>
 *     <input type="text" name="company" tabindex="-1">   piege a bots, masque en CSS
 *     <button type="submit">Je m'inscris</button>
 *     <p data-sio-success>C'est fait.</p>
 *     <p data-sio-error><span>Une erreur est survenue.</span></p>
 *   </form>
 *
 * Attributs optionnels sur le <form> :
 *   data-redirect="/pages/merci"   redirige apres inscription
 *   data-loading="Envoi..."        texte du bouton pendant l'envoi
 *   data-done-class="is-done"      classe posee sur le conteneur en cas de succes
 *
 * Deux comportements de l'endpoint Systeme.io a connaitre :
 *   - il repond 200 meme quand il REFUSE, le verdict est dans le corps de la
 *     reponse (f-control-error / f-help-error)
 *   - quand il ACCEPTE, il redirige vers une page de confirmation qui n'a pas
 *     d'en-tetes CORS. Suivre la redirection fait echouer fetch alors que
 *     l'inscription a reussi, d'ou redirect:'manual'
 */
(function () {
  'use strict';

  var SELECTOR = '[data-sio-form]';
  var bound = 'sioFormBound';

  function setup(form) {
    if (form.dataset[bound]) return;
    form.dataset[bound] = '1';

    var button = form.querySelector('[type="submit"]');
    var email = form.querySelector('input[type="email"]');
    var honeypot = form.querySelector('input[name="company"]');
    var success = form.querySelector('[data-sio-success]');
    var error = form.querySelector('[data-sio-error]');
    if (!button || !email) return;

    var label = button.textContent.trim();
    var loading = form.dataset.loading || label;
    var redirect = form.dataset.redirect || '';
    var doneClass = form.dataset.doneClass || 'sio-form--is-done';
    var container = form.closest('.sio-form') || form.parentNode;

    function show(el) {
      if (success) success.classList.remove('is-visible');
      if (error) error.classList.remove('is-visible');
      if (el) el.classList.add('is-visible');
    }

    function busy(state) {
      button.setAttribute('aria-busy', state ? 'true' : 'false');
      button.textContent = state ? loading : label;
    }

    function fail(message) {
      if (error) {
        var slot = error.querySelector('span:last-child') || error;
        if (message) slot.textContent = message;
      }
      show(error);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (honeypot && honeypot.value) return; // bot

      if (!email.checkValidity()) {
        email.focus();
        fail(null);
        return;
      }

      var data = new URLSearchParams();
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.name === 'company' || !el.value) return;
        data.append(el.name, el.value.trim());
      });

      busy(true);
      show(null);

      fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
        redirect: 'manual'
      })
        .then(function (response) {
          // Reponse opaque = redirection = Systeme.io a accepte
          if (response.type === 'opaqueredirect') return '';

          if (!response.ok) {
            var unreachable = new Error('http ' + response.status);
            unreachable.unreachable = true;
            throw unreachable;
          }

          return response.text();
        })
        .then(function (html) {
          if (html && /f-(control|help)-error/.test(html)) {
            var found = html.match(/f-help-error[^>]*>\s*([^<]+)/);
            var refusal = new Error(found ? found[1].trim() : '');
            refusal.refused = true;
            throw refusal;
          }

          busy(false);
          if (redirect) {
            window.location.href = redirect;
            return;
          }
          if (container && container.classList) container.classList.add(doneClass);
          show(success);
        })
        .catch(function (err) {
          busy(false);

          // Refus de Systeme.io : on affiche son message, en francais
          if (err && err.refused) {
            fail(err.message || null);
            return;
          }

          // Reseau injoignable : envoi classique. Le visiteur finit sur la page
          // Systeme.io, mais le lead est capte plutot que perdu.
          form.submit();
        });
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // L'editeur de theme recharge les sections sans recharger la page
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
